import { render, staticRenderFns } from "./bold1.vue?vue&type=template&id=549cd837&scoped=true&"
import script from "./bold1.vue?vue&type=script&lang=js&"
export * from "./bold1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549cd837",
  null
  
)

export default component.exports